export default "__VITE_ASSET__CRawr3Tu__"